import React, { memo } from "react";
import { Helmet } from "react-helmet-async";

import {
  IS_WHITE_LABELED_DOMAIN,
  SITE_NAME,
  SITE_URL,
  WHITE_LABELED_DOMAIN_URL,
} from "@/config/appConfig";

const getBaseUrl = () =>
  IS_WHITE_LABELED_DOMAIN ? WHITE_LABELED_DOMAIN_URL : SITE_URL;

const buildAbsoluteUrl = (path = "") => {
  const baseUrl = getBaseUrl()?.replace(/\/+$/, "");
  const normalizedPath = path ? String(path).replace(/^\/+/, "") : "";

  if (!baseUrl) return "";

  return normalizedPath ? `${baseUrl}/${normalizedPath}` : baseUrl;
};

function MainSEO({
  title,
  description = `Brand Directed. ${SITE_NAME}. The ${SITE_NAME} advertising platform gives you the power of sophisticated digital marketing, backed by your brand, in an easy-to-use dashboard. Promote your business like a pro in just a few clicks!`,
  url,
  image = buildAbsoluteUrl(
    `img/${IS_WHITE_LABELED_DOMAIN ? "LocallyPerfected" : "Hyperlocology"}.png`
  ),
}) {
  const formattedTitle = title ? `${title} - ${SITE_NAME}` : SITE_NAME;
  const formattedURL = buildAbsoluteUrl(url);

  return (
    <Helmet>
      <link rel="canonical" href={formattedURL} />

      <title>{formattedTitle}</title>
      <meta name="title" content={formattedTitle} />
      <meta name="description" content={description} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={formattedURL} />
      <meta property="og:title" content={formattedTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={formattedURL} />
      <meta property="twitter:title" content={formattedTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
    </Helmet>
  );
}

export default memo(MainSEO);
